function setupPasswordToggle(inputId, toggleId) {
  const passwordInput = document.getElementById(inputId);
  const toggleButton = document.getElementById(toggleId);

  if (!passwordInput || !toggleButton) return;

  toggleButton.addEventListener("click", () => {
    const isPassword = passwordInput.getAttribute("type") === "password";
    passwordInput.setAttribute("type", isPassword ? "text" : "password");
    toggleButton.textContent = isPassword ? "Hide" : "Show";
  });
}

setupPasswordToggle("CustomerPassword", "togglePassword");
setupPasswordToggle("password", "toggleNewPassword");
setupPasswordToggle("password_confirmation", "toggleConfirmPassword");
